import { Map, Record } from "immutable";

import { CrudBuilderState } from "seneca-common/utils/apiStates";

import Location from "./state/locations/location/Location";
import { Locations } from "./state/locations/Locations";
import locationsMetaInitialState from "./state/meta";

export type LocationsStateSliceType = {
  locations: Locations;
  meta: CrudBuilderState | Map<any, any>;
};

export type OptionalLocationsStateSliceType = Partial<LocationsStateSliceType>;

const defaultLocationsStateSlice: LocationsStateSliceType = {
  locations: Map<string, Location>(),
  meta: locationsMetaInitialState
};

export default class LocationsStateSlice extends Record(
  defaultLocationsStateSlice
) {}
